import React from "react";
import { IUserInstancePermission } from "../../../domain/UserInstancePermission";
import { Badge, Disclose, Icon, Poptip, Table } from "@optimizely/axiom";
import styles from "./UserPermissionsDisplay.module.scss";

type PermissionsByOrganization = {
    [organizationId: string]: IUserInstancePermission[];
};
export const UserPermissionsDisplay = ({ permissions }: { permissions: IUserInstancePermission[] }) => {
    if (!permissions.length) {
        return <div>No permissions to display.</div>;
    }

    const byOrganization: PermissionsByOrganization = permissions.reduce((byOrg, permission) => {
        if (!byOrg[permission.organizationId]) {
            byOrg[permission.organizationId] = [];
        }
        byOrg[permission.organizationId].push(permission);
        return byOrg;
    }, {} as PermissionsByOrganization);

    return (
        <div className={styles["user-permissions-display"]}>
            {Object.keys(byOrganization)
                .sort((a, b) => {
                    const nameA = byOrganization[a][0].organizationName;
                    const nameB = byOrganization[b][0].organizationName;
                    return nameA.localeCompare(nameB);
                })
                .map((organizationId) => {
                    const organizationPermissions = byOrganization[organizationId];
                    const organizationName = organizationPermissions[0].organizationName;
                    const isHomeOrganization = organizationPermissions[0].isHomeOrganization;
                    return (
                        <Disclose
                            key={`disclose-header-${organizationId}`}
                            title={
                                <div className={styles["user-permissions-display__disclose-header"]}>
                                    <span>
                                        {organizationName} ({organizationPermissions.length})
                                    </span>
                                    {isHomeOrganization && (
                                        <Poptip content="Home Organization">
                                            <Icon size="small" name="house" />
                                        </Poptip>
                                    )}
                                </div>
                            }
                        >
                            <div className="push-triple--left ">
                                <Table
                                    shouldAddHover={false}
                                    tableLayoutAlgorithm="auto"
                                    key={`table-${organizationId}`}
                                >
                                    <Table.THead>
                                        <Table.TR>
                                            <Table.TH sorting={{}} width="30%">
                                                Product
                                            </Table.TH>
                                            <Table.TH sorting={{}} width="30%">
                                                Instance
                                            </Table.TH>
                                            <Table.TH sorting={{}} width="40%">
                                                Role(s)
                                            </Table.TH>
                                        </Table.TR>
                                    </Table.THead>
                                    <Table.TBody>
                                        {organizationPermissions.map((permission, pIndex) => {
                                            return (
                                                <Table.TR
                                                    className={styles["user-permissions-display__table-row"]}
                                                    key={`${pIndex}-${permission.instanceId}`}
                                                >
                                                    <Table.TD>{permission.productName}</Table.TD>
                                                    <Table.TD>
                                                        {permission.nickname || permission.instanceName}
                                                    </Table.TD>
                                                    <Table.TD>
                                                        {permission.roles.length > 0
                                                            ? permission.roles.map((r, idx) => (
                                                                  <Badge key={r.id || idx} className="height--auto">
                                                                      {r.name}
                                                                  </Badge>
                                                              ))
                                                            : "N/A"}
                                                    </Table.TD>
                                                </Table.TR>
                                            );
                                        })}
                                    </Table.TBody>
                                </Table>
                            </div>
                        </Disclose>
                    );
                })}
        </div>
    );
};

UserPermissionsDisplay.displayName = "UserPermissionsDisplay";
